import {BasicCriteria} from '../../../allkey/framework/parameters/BasicCriteria';

export class ChronocodeCriteria extends BasicCriteria {
chronocodeCodeList: string[];
minusOneYear: boolean | null;
rootCode: string;
}

